import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import PropTypes from 'prop-types';
import {deleteEsimInstruction, deleteEsimBySystem} from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {setShowPopUp} from './../TransferOrganizationAccountSlice';
import {connect} from 'react-redux';

const DeleteEsimPopUp = (props) => {
  return (
    <div className='deleteEsimPopUp'>
      <div className='body'>
        <Image src={require('../icons/light120.svg')} />
        <div className='L_Title'> מחיקת eSIM ישן מהמכשיר</div>
        <div className='description'>
          במידה ויש eSIM שכבר מותקן על המכשיר, ה-eSIM שיופעל עכשיו יוגדר משני באופן אוטומטי. זה אומר שהשיחות, ההודעות והגלישה יתבססו על
          ה-eSIM הישן ולא החדש
        </div>
        <div className='frame'>
          <p className='M_Title'>אז מה עושים?</p>
          <div className='deleteEsimInstruction'>
            <ol>
              {deleteEsimInstruction.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ol>
          </div>
        </div>
        <div className='frame'>
          <p className='M_Title'>איך עושים את זה ?</p>
          <div className='deleteEsimBySystem'>
            {deleteEsimBySystem.map((item, index) => {
              return (
                <div key={index}>
                  <Image src={item.icon} />
                  <p>{item.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className='btn_submit_container'>
        <BtnSubmit
          text={'הבנתי,תודה'}
          onclick={() => {
            props.setShowPopUp(false);
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {setShowPopUp};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteEsimPopUp);
